<script setup>
// import i18n from "@/i18n"
import { defineProps, defineEmits, watch, ref, inject } from "vue";
import Swal from "sweetalert2";
import { useRoute } from "vue-router";
import copySvg from "@/assets/images/svg/copy.svg"
import {  getLangValueByKey } from "@/utils/common"; //获取后端语言
const currentTabLang = inject('currentTabLang') //切换语言
const props = defineProps({
    uploadList: {
        type: Array,
        required: true,
        default: () => []
    },
})
const route = useRoute()
const emits = defineEmits(["update:uploadList"])
// const { uploadList } = toRefs(props)
const uploadList = ref(props.uploadList);

watch(() => props.uploadList, (newVal) => {
    uploadList.value = newVal;
});
const handlerDelete = (index) => {
    Swal.fire({
        title: currentTabLang.value ==1?getLangValueByKey("base.delete_alert_title"): getLangValueByKey("base.delete_alert_title", 'en'),
        text: currentTabLang.value ==1?getLangValueByKey("base.delete_alert_info"): getLangValueByKey("base.delete_alert_info", 'en'),
        icon: "warning",
        showCancelButton: true,
        cancelButtonColor: "#f46a6a",
        confirmButtonColor: "#34c38f",
        confirmButtonText: currentTabLang.value ==1?  getLangValueByKey("base.done"): getLangValueByKey("base.done", 'en'),
        cancelButtonText: currentTabLang.value ==1?  getLangValueByKey("base.cancel"): getLangValueByKey("base.cancel", 'en'),
    }).then(async (result) => {
        if (result.isConfirmed) {
            uploadList.value.splice(index, 1)
            emits("update:uploadList", uploadList.value)
        }
    });

}
const editFields = (i) => {
    //tab 字段名称修改
    const { name, name_en } = uploadList.value[i];
    Swal.fire({
        title:currentTabLang.value ==1?  getLangValueByKey("product-template.enterFieldName"): getLangValueByKey("product-template.enterFieldName", 'en'),
        input: "text",
        inputValue: currentTabLang.value == 1 ? name : name_en,
        showCancelButton: true,
        confirmButtonText: currentTabLang.value ==1?  getLangValueByKey("base.done"): getLangValueByKey("base.done", 'en'),
        cancelButtonText: currentTabLang.value ==1?  getLangValueByKey("base.cancel"): getLangValueByKey("base.cancel", 'en'),
        showLoaderOnConfirm: true,
        confirmButtonColor: "#0AB39c",
        cancelButtonColor: "#f06548",
        inputValidator: (value) => {
            if (!value) {
                return currentTabLang.value == 1? getLangValueByKey("product-template.requeiredInfo"): getLangValueByKey("product-template.requeiredInfo", 'en')
            }
        },
        preConfirm: (value) => {
            if (value) {
                if (currentTabLang.value == 1) {
                    uploadList.value[i].name = value
                } else {
                    uploadList.value[i].name_en = value
                }
                emits('update:uploadList', uploadList.value)
            }
        },
        allowOutsideClick: false,
    }).then((text) => {
        console.log(text);
    });
}

const handlerSwitch = () => {
    emits('update:uploadList', uploadList.value)
}

const deleteField = (index, index_field) => {
    const { fieldsList } = uploadList.value[index]
    fieldsList.splice(index_field, 1)
    emits('update:uploadList', uploadList.value)
}
const editField = (index, index_field) => {
    const { fieldsList } = uploadList.value[index]
    const { name, name_en } = fieldsList[index_field]
    Swal.fire({
        title:currentTabLang.value ==1?  getLangValueByKey("product-template.enterFieldName"): getLangValueByKey("product-template.enterFieldName", 'en'),
        input: "text",
        inputValue: currentTabLang.value == 1 ? name : name_en,
        showCancelButton: true,
        confirmButtonText: currentTabLang.value ==1?  getLangValueByKey("base.done"): getLangValueByKey("base.done", 'en'),
        cancelButtonText: currentTabLang.value ==1?  getLangValueByKey("base.cancel"): getLangValueByKey("base.cancel", 'en'),
        showLoaderOnConfirm: true,
        confirmButtonColor: "#0AB39c",
        cancelButtonColor: "#f06548",
        inputValidator: (value) => {
            if (!value) {
                return currentTabLang.value == 1? getLangValueByKey("product-template.requeiredInfo"): getLangValueByKey("product-template.requeiredInfo", 'en')
            }
        },
        preConfirm: (value) => {
            if (value) {
                if(currentTabLang.value == 1) {
                    fieldsList[index_field].name = value
                }else{
                    fieldsList[index_field].name_en = value
                }
                emits('update:uploadList', uploadList.value)
            }

        },
        allowOutsideClick: false,
    }).then((text) => {
        console.log(text);
    });
}

const copyUpload = (i) => {
    // console.log(uploadList.value[i]);
    let m = { ...uploadList.value[i] };
    m.id = `${m.id}${uploadList.value.length + 1}`
    m.mykey = m.key
    m.key = `${m.key}${uploadList.value.length + 1}`
    // console.log(m);
    uploadList.value = [
        ...uploadList.value.slice(0, i + 1),
        m,
        ...uploadList.value.slice(i + 1),
    ];
    emits('update:uploadList', uploadList.value)
}

// watch(uploadList, (val)=> {
//     console.log(val);
// },{deep:true})

</script>
<template>
    <template v-for="(item, index) in uploadList" :key="index">
        <b-card v-show="route.query.type != 'view' || (route.query.type == 'view' && item.isShow)">
            <div class="row gy-3 w-100">
                <div class="d-flex justify-content-between align-items-center pt-2 pb-2"
                    style="font-weight: 500;border-bottom: 1px solid #E9EBEC; font-size: 16px;">
                    <div class="d-flex align-items-center">
                        <span v-if="route.query.type == 'view'">
                            <span class="text-danger" v-if="item.required">*</span>
                        </span>
                        <input v-else class="form-check-input mt-0" type="checkbox" v-model="item.required"
                            aria-label="Checkbox for following text input">
                        <span class="mx-2">{{ currentTabLang ==1?item.name: item.name_en }}</span>
                        <i v-if="route.query.type != 'view'" class="ri-pencil-fill cursor-pointer"
                            @click.stop="editFields(index)"></i>
                    </div>
                    <div style="width: 135px;" class="d-flex align-items-center justify-content-between"
                        v-if="route.query.type != 'view'">
                        <div class="form-check form-switch form-switch-success">
                            <input class="form-check-input" v-model="item.isShow" @change="handlerSwitch"
                                type="checkbox" role="switch" id="SwitchCheck3" checked>
                        </div>
                        <img class="cursor-pointer" :src="copySvg" @click="copyUpload(index)" style="width: 24px;" />
                        <i style="color:#ED5E5E" @click="handlerDelete(index)"
                            class=" cursor-pointer ri-delete-bin-5-fill me-1 align-bottom"></i>
                        <!-- <button :disabled="route.query.type == 'view'" type="button" class="btn btn-success me-3" style="background-color: #F06548;border:unset"
                        @click="handlerDelete(index)">
                        <i class="ri-delete-bin-5-fill me-1 align-bottom"></i>
                        {{ getLangValue("base.delete") }}
                    </button> -->
                    </div>
                </div>
                <div class="row  d-flex justify-content-start" v-if="item.fieldsList">
                    <!-- 新增字段部分 -->
                    <div class="col-4 mt-2" v-for="(field, index_field) in item.fieldsList" :key="index_field">
                        <label class="form-label">
                            <span class="text-danger"></span>
                            <span>{{ currentTabLang ==1?  field.name : field.name_en }}</span>
                            <i v-if="route.query.type != 'view'" class="ri-pencil-fill cursor-pointer"
                                @click="editField(index, index_field)"></i>
                        </label>
                        <div class="d-flex align-items-center">
                            <div style="display: inline; flex:1">
                                <div class="input-group" style="display: flex;">
                                    <input type="text" class="form-control" disabled style="flex: 1;">
                                    <div class="input-group-text"> <input style="max-width:20px; display: inline;"
                                            class="form-check-input mt-0" type="checkbox"
                                            :disabled="route.query.type == 'view'" v-model="field.required"
                                            aria-label="Checkbox for following text input"></div>
                                </div>
                            </div>
                            <i v-if="route.query.type !== 'view'" class="fs-16 ri-delete-bin-5-fill cursor-pointer"
                                style="color: #F06548; margin-left: 4px;" @click="deleteField(index, index_field)"></i>
                        </div>
                    </div>
                </div>
                <!-- 上传框 -->
                <div style="pointer-events: none;">
                    <DropZone1 :title="currentTabLang==1? getLangValueByKey('upload.title'):getLangValueByKey('upload.title', 'en') " :accept="'.png,.jpeg,.jpg,'" @drop.prevent="drop"
                        @change.prevent="selectedFile('2d')" style="min-height: 220px" limit="50M"
                        :info="item.info ? item.info : ''" :currentTab="currentTabLang" />
                </div>
            </div>
        </b-card>
    </template>
</template>
<style></style>